var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1655_104873)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9548 23.347C35.5958 22.7838 35.9602 21.9667 35.9602 21.1073V16.5686H37.6359C38.0967 16.5686 38.4737 16.1875 38.4737 15.7218C38.4737 15.2561 38.0967 14.875 37.6359 14.875H18.3652C17.9044 14.875 17.5273 15.2561 17.5273 15.7218C17.5273 16.1875 17.9044 16.5686 18.3652 16.5686H20.0409V21.5222C20.0409 22.3859 20.4096 23.2073 21.0589 23.7704L24.779 27.0304C25.0597 27.276 25.2189 27.6232 25.2189 28C25.2189 28.3768 25.0639 28.724 24.779 28.9696L21.0589 32.2254C20.4096 32.7927 20.0409 33.6141 20.0409 34.4778V39.4314H18.3652C17.9044 39.4314 17.5273 39.8125 17.5273 40.2782C17.5273 40.7439 17.9044 41.125 18.3652 41.125H37.6359C38.0967 41.125 38.4737 40.7439 38.4737 40.2782C38.4737 39.8125 38.0967 39.4314 37.6359 39.4314H35.9602V34.8927C35.9602 34.0333 35.5915 33.2162 34.9548 32.653L30.7823 28.9653C30.5016 28.7197 30.3508 28.3768 30.3508 28C30.3508 27.6232 30.5058 27.2803 30.7823 27.0347L34.9548 23.347ZM29.6804 30.2396L33.8529 33.9274C34.1295 34.1729 34.2844 34.5243 34.2844 34.8927V39.4313H21.7166V34.4777C21.7166 34.1051 21.8758 33.7537 22.1523 33.5082L25.8724 30.2523C26.5176 29.685 26.8904 28.8679 26.8904 28.0042C26.8904 27.1404 26.5217 26.3191 25.8724 25.756L22.1523 22.4959C21.8758 22.2503 21.7166 21.8947 21.7166 21.5222V16.5685H34.2845V21.1072C34.2845 21.4755 34.1253 21.8269 33.8488 22.0725L29.6762 25.7602C29.0394 26.3233 28.6708 27.1404 28.6708 27.9999C28.6708 28.8594 29.0395 29.6765 29.6804 30.2396Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4466 21.1072V20.4298C33.4466 20.1673 33.2371 19.9556 32.9816 19.9556H23.0195C22.7639 19.9556 22.5545 20.1673 22.5545 20.4256V21.5221C22.5545 21.772 22.6634 22.009 22.8477 22.17L26.5092 25.3792C26.9616 25.7772 27.3345 26.2726 27.5314 26.8441C28.009 28.2159 27.5901 29.6724 26.5679 30.5657L22.8478 33.8257C22.6635 33.9909 22.5545 34.2237 22.5545 34.4735V38.2036C22.5545 38.4152 22.7221 38.5846 22.9274 38.5846H33.0739C33.2791 38.5846 33.4467 38.4152 33.4467 38.2078V34.8927C33.4467 34.6429 33.342 34.41 33.1577 34.2449L29.0564 30.6165C28.6081 30.2185 28.2395 29.7274 28.0383 29.16C27.5566 27.7925 27.9713 26.3403 28.9851 25.4385L33.1577 21.7508C33.3419 21.5899 33.4466 21.3528 33.4466 21.1072Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1655_104873",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStatus);
export default __webpack_public_path__ + "static/media/Home_Status.e7500d1dd4f9bcbe96f8f253e51ef510.svg";
export { ForwardRef as ReactComponent };